// extracted by mini-css-extract-plugin
export default {"container":"Inicio_container__JTTny","inicio":"Inicio_inicio__9lAVu","botaoSkins":"Inicio_botaoSkins__CChjv"};